import { Chip } from "@mui/material";
import React, { FC, MouseEventHandler, useEffect, useState } from 'react';
import { Button } from "../button";
import { Cross } from "../svgs";

interface SelectContentMultipleProps {
  value: any[];
  placeholder: string;
  search?: boolean;
  getOptionLabel?: (option: unknown) => string;
  getOptionId?: (option: unknown) => string | number;
}

export const SelectContentMultiple: FC<SelectContentMultipleProps> = ({
  value, placeholder, search, getOptionId, getOptionLabel
}) => {
  const [openListValues, setOpenListValues] = useState(false);
  useEffect(() => {
    Array.isArray(value) && !value?.length && setOpenListValues(false);
  }, [value]);
  const toggleListValues: MouseEventHandler = (e) => {
    e.stopPropagation();
    setOpenListValues(prev => !prev);
  };

  if (!value.length && !search)
    return (
      <span className="placeholder">
        {placeholder}
      </span>
    );
  return (
    <>
      {(!openListValues ? value.slice(0, 3) : value).map(obj => (
        <Chip
          className="chip"
          key={getOptionId(obj)}
          label={getOptionLabel(obj)}
          deleteIcon={<Cross divClassName="delete-icon" />}
        />
      ))}
      {!openListValues && value.length > 3 && (
        <Button className="open-members-list-button" title={`+${value.length - 3}`} onClick={toggleListValues} />
      )}
      {openListValues && (
        <div className="close-list-button-container">
          <Button className="close-members-list-button outlined-borderless" title="Свернуть" onClick={toggleListValues} />
        </div>
      )}
    </>
  );
};